import { CatalogResourceType, ResourceTypeLink } from "@evergis/api";
import React, { FC } from "react";

import { useLayersDropdownList } from "../../hooks/project/useProjectLayers";
import { ResourcesSelectorDropdown } from "../ResourceSelector/ResourcesSelectorDropdown";

import { LayersSelectorProps } from "./types";

export const LayersSelector: FC<LayersSelectorProps> = ({
  hiddenLayers,
  layerGeometryType,
  layer,
  withCatalog,
  layerTypes,
  onChange,
  ...props
}) => {
  const [layerOptions, layerOptionsLoading] = useLayersDropdownList({
    geometryType: layerGeometryType,
    serviceTypes: layerTypes,
    layerName: layer,
  });

  return (
    <ResourcesSelectorDropdown
      resourceName={layer}
      hiddenResources={hiddenLayers}
      withCatalog={withCatalog}
      onChange={onChange}
      resourceOptions={layerOptions}
      loading={layerOptionsLoading}
      resourceType={ResourceTypeLink.Layer}
      resourceCatalogFilters={{ resourceTypes: [CatalogResourceType.Layer] }}
      {...props}
    />
  );
};
